'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { checkboxVariants } from "../Checkbox/Checkbox.variants.js";
import { cn } from "../../../utils/index.js";
import { Label } from "../../Label/index.js";
import { Checkbox } from "../Checkbox/Checkbox.js";
const CheckboxWithLabel = (props)=>{
    const { emphasis, size = '20', labelClassName, labelProps = {}, labelNode, isCheckboxGroup = false, layout, ...restProps } = props;
    const { labelSlot } = checkboxVariants({
        size,
        emphasis,
        isCheckboxGroup,
        layout
    });
    const labelClasses = cn(labelSlot(), labelClassName);
    return /*#__PURE__*/ jsxs(Label, {
        className: labelClasses,
        ...labelProps,
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ jsx(Checkbox, {
                size: size,
                emphasis: emphasis,
                isCheckboxGroup: isCheckboxGroup,
                ...restProps
            }),
            labelNode
        ]
    });
};
export { CheckboxWithLabel };
